function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99159 4.72193L9.98618 4.65238C10.0185 5.11502 9.98697 5.58213 9.8905 6.03927L8.89582 5.9067C8.98639 5.51677 9.01784 5.11706 8.99159 4.72193Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.98027 2.37687C0.530384 4.04478 0.706968 6.57006 2.37488 8.01995C3.8493 9.30165 5.99372 9.31233 7.47298 8.14537L8.10182 8.92297C6.25295 10.3884 3.5635 10.3782 1.71882 8.77466C-0.364181 6.96393 -0.585158 3.80381 1.22556 1.72081C2.21319 0.584681 3.60225 0.00249072 4.99902 0.00177588L4.99902 1.00209C3.88197 1.0013 2.77133 1.46686 1.98027 2.37687Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.18597 4.02403L6.56041 2.44291L7.22366 1.68093L7.88691 0.918956C8.02138 1.0143 8.1524 1.11715 8.27941 1.22756L8.65676 1.55559L5.94068 4.68009C6.05556 5.00521 5.99656 5.37792 5.75382 5.65717C5.39299 6.07226 4.75814 6.11665 4.34305 5.75582C3.92796 5.39498 3.88357 4.76014 4.2444 4.34505C4.48714 4.06581 4.84474 3.95928 5.18597 4.02403Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.63212 6.88412C9.43019 7.38126 9.14419 7.854 8.77266 8.2814C8.74583 8.31227 8.7187 8.34273 8.69128 8.37278L8.01795 7.62534C8.28588 7.31713 8.49801 6.97941 8.65557 6.62463L9.63212 6.88412Z"
});

var SvgTrackChanges = function SvgTrackChanges(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrackChanges, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/track_changes.b2fbc4de.svg";
export { ForwardRef as ReactComponent };